import { typeCartAssignment, typeCartParticipant, typeCartParticipantBlinded, typeCartPeriod, typeCartPoint, typeCartsDoc } from '@monorepo/models';

class CartHelper {
    GetPriorityPoints = (participant: typeCartParticipant, cartAssignments: typeCartAssignment[], month: number, year: number): number => {
        let priorityPoints = 0;
        if (participant.priority === 1) {
            priorityPoints += 60;
        }
        if (participant.priority === 2) {
            priorityPoints += 30;
        }
        if (participant.hasParticipatedBefore) {
            priorityPoints += 50;
        }
        participant.availabilities.forEach(() => {
            priorityPoints -= 20;
        });
        cartAssignments.filter(a => a.participants.some(p => p.userId === participant.userId) && a.year === year && a.month === month).forEach(() => {
            priorityPoints -= 50;
        });
        return priorityPoints;
    }
    GetTimeFromPeriodData = (startHour: number, startMinutes: number, endHour: number, endMinutes: number): string => {
        return `${startHour.toString().padStart(2, '0')}:${startMinutes.toString().padStart(2, '0')}-${endHour.toString().padStart(2, '0')}:${endMinutes.toString().padStart(2, '0')}`;
    }
    IsOverlappingParticipant = (cartsDoc: typeCartsDoc, month: number, participants: typeCartParticipantBlinded[], period: typeCartPeriod, point: typeCartPoint, weekday: number, year: number): boolean => {
        return cartsDoc.assignments.some(a => {
            if (a.year === year && a.month === month && a.weekday === weekday) {
                const hasTheseParticipants = a.participants.some(p => [participants[0].userId, participants[1].userId].includes(p.userId));
                if (!hasTheseParticipants) {
                    return false;
                }
                const existingStart = (a.startHour ?? 0) * 60 + (a.startMinutes ?? 0);
                const existingEnd = (a.endHour ?? 0) * 60 + (a.endMinutes ?? 0);
                const newStart = period.startHour * 60 + period.startMinutes;
                const newEnd = period.endHour * 60 + period.endMinutes;
                return newStart < existingEnd && newEnd > existingStart;
            }
            return false;
        });
    }
    IsOverlappingPoint = (cartsDoc: typeCartsDoc, month: number, period: typeCartPeriod, point: typeCartPoint, weekday: number, year: number): boolean => {
        return cartsDoc.assignments.some(a => {
            if (a.year === year && a.month === month && a.weekday === weekday && a.pointId === point.id) {
                const existingStart = (a.startHour ?? 0) * 60 + (a.startMinutes ?? 0);
                const existingEnd = (a.endHour ?? 0) * 60 + (a.endMinutes ?? 0);
                const newStart = period.startHour * 60 + period.startMinutes;
                const newEnd = period.endHour * 60 + period.endMinutes;
                return newStart < existingEnd && newEnd > existingStart;
            }
            return false;
        });
    }
}

export const cartHelper = new CartHelper();
